import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Tabs, Tab } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

const Section7 = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // Retrieve initial type from the URL; default to "1" if not present
  const queryParams = new URLSearchParams(location.search);
  const initialType = queryParams.get('type') || '1';

  // Local state for the selected tab (for navigation) and displayed tab (for animation)
  const [selectedTab, setSelectedTab] = useState(initialType);
  const [displayedTab, setDisplayedTab] = useState(initialType);

  // Animation stage: 'fade-in', 'fade-out', or 'pre-slide'
  const [animationClass, setAnimationClass] = useState('fade-in');

  // Sync local state with URL param if it changes externally
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const typeFromUrl = params.get('type') || '1';
    if (typeFromUrl !== selectedTab) {
      setSelectedTab(typeFromUrl);
    }
  }, [location.search, selectedTab]);

  useEffect(() => {
    if (selectedTab !== displayedTab) {
      // Step 1: Fade-out and slide out to the left
      setAnimationClass('fade-out');
      const fadeOutTimer = setTimeout(() => {
        // Step 2: Update content and position it off-screen right
        setDisplayedTab(selectedTab);
        setAnimationClass('pre-slide');
        // Step 3: Trigger fade-in and slide in from the right
        const slideInTimer = setTimeout(() => {
          setAnimationClass('fade-in');
        }, 50); // A short delay to allow the browser to apply the "pre-slide" state
        return () => clearTimeout(slideInTimer);
      }, 300); // Matches the fade-out transition duration
      return () => clearTimeout(fadeOutTimer);
    }
  }, [selectedTab, displayedTab]);

  const handleScroll = (id) => {
    navigate(`/`);
    setTimeout(() => {
      const element = document.getElementById(id);
      if (element) {
        window.scrollTo({
          top: element.offsetTop - 80,
          behavior: 'smooth',
        });
      }
    }, 500);
  };

  return (
    <div
      style={{
        minHeight: '50vh',
        marginTop: '10vh',
        paddingBottom: '100px',
      }}
    >
      <div
        className={`fade-container container ${animationClass}`}
        style={{ paddingTop: '100px', textAlign: 'left', maxWidth: '1000px' }}
      >
        <div className="col-md-12 col-12">
          <h1 className="title">
            {t('serviceBottom' + displayedTab)}{' '}
            <span className="gradient-text">
              {t('serviceBottomFe' + displayedTab)}{' '}
            </span>{' '}
          </h1>
          <h1 style={{ marginTop: '-10px' }} className="title">
            {t('serviceBottomAfter' + displayedTab)}
          </h1>
          <p className="text mt-3">{t('serviceBottomDesc' + displayedTab)}</p>
          <p className="text mt-3">{t('serviceBottomDesc2' + displayedTab)}</p>
        </div>
        <div className="row">
          <div className="col-md-7 col-12">
            <div style={{ maxWidth: '650px' }}>
              <h4 style={{ maxWidth: '90%' }} className="section-title mt-5">
                {t('feature1' + displayedTab)}
              </h4>
              <p className="text mt-1">{t('feature1Desc' + displayedTab)}</p>
            </div>
            <div style={{ maxWidth: '650px' }}>
              <h4 style={{ maxWidth: '90%' }} className="section-title mt-5">
                {t('feature2' + displayedTab)}
              </h4>
              <p className="text mt-1">{t('feature2Desc' + displayedTab)}</p>
            </div>
            <div style={{ maxWidth: '650px' }}>
              <h4 style={{ maxWidth: '90%' }} className="section-title mt-5">
                {t('feature3' + displayedTab)}
              </h4>
              <p className="text mt-1">{t('feature3Desc' + displayedTab)}</p>
            </div>
          </div>
        </div>
        <Button
          onClick={() => handleScroll('section2')}
          className="mt-5 button-black"
          variant="contained"
          color="primary"
          style={{
            backgroundColor: '#000000',
            color: '#FFFFFF',
            borderRadius: '30px',
            padding: '8px 25px',
          }}
        >
          {t('getQuote')}
        </Button>
      </div>
    </div>
  );
};

export default Section7;
